import Model from 'src/storage/base';
import LANG_CONST from 'src/helpers/lang/const';

class SettingQuestionModel extends Model {
  id = 'SettingQuestionModel';
  defaultState = () => ({ questions: [], newQuestion: '' });
  persistent = false;
  apiConfig = {
    addQuestions: {
      url: 'profile/update/questions',
      validation: {
        questions: 'array',
        newQuestion: 'question'
      },
      cancellable: true
    },
    delQuestions: {
      url: 'profile/update/questions',
      validation: {
        questions: 'questions'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile'
  };

  handleProfile = ({ password, ...profile }) => {
    void password;
    this.setState({ ...profile, user: profile });
  };

  resetQuestions = () => {
    let user = this.state.user;
    const questions = Array.isArray(user?.questions) ? user.questions : [];
    this.resetApiState('delQuestions');
    this.resetApiState('addQuestions');

    this.setState({
      questions: [...questions],
      newQuestion: ''
    });
  };

  saveQuestions = (isDel = false, cb) => {
    let req = {
      questions: [...this.state.questions]
    };
    let api = 'delQuestions';
    if (!isDel) {
      api = 'addQuestions';
      if (req.questions.length >= 30) {
        return this.setInvalidApi(api, { newQuestion: LANG_CONST.notice.limit_reached });
      }
      req.questions.push(this.state.newQuestion);
      req.newQuestion = this.state.newQuestion;
    }
    this.api(api, req, (error, data, success) => {
      if (success) {
        this.setState({
          questions: req.questions,
          newQuestion: ''
        });
      }
      cb && cb(error, data);
    });
  };
}

const model = new SettingQuestionModel();
export default model;
